import { Component, Input, OnInit } from '@angular/core';
import {EvaluationBaseTileComponent} from '../tile.component';
import {LicenseService} from '../../../../services/license.service';
import {EnvironmentService} from '../../../../services/environment.service';
import {EvaluationService} from '../../evaluation.service';

@Component({
    selector: 'itpx-evaluation-ebook-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.css']
})
export class EvaluationEBookTileComponent extends EvaluationBaseTileComponent implements OnInit {
    @Input() deliverable: any;

    private images: string;
    private href: string = '#';

    constructor(
        private licenseService: LicenseService,
        private environmentService: EnvironmentService,
        private service: EvaluationService
    ) {
        super();
    }

    ngOnInit() {
        this.images = this.environmentService.config['server'].images;
        super.init(this.licenseService, this.deliverable, false);
    }

    complete(deliverable: any, createTarget: boolean) {
      this.href = this.service.getSphinxUrl(deliverable.contents[0].evaluationVoucherSourceBucket, deliverable.contents[0].evaluationVoucherSourceKey);
      super.complete(deliverable, createTarget);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/content/ebook/tile.component.ts